// Shared policy for the admin search boxes (customers list, requests, feedback).
//
// It used to be a cost control. A patient search by name was a "contains" regex
// on users (server/Controllers/Utils/userSearch.js) that no index could serve,
// and the count that came with each page read the whole collection — so the box
// waited 600ms for a real pause and refused anything under 3 characters, to
// search as few times as possible.
//
// Names now go through the `users_search` Atlas Search index, so finding the
// matches is an index lookup and the count is over the matches instead of over
// ~962k users. The two knobs stay, for the two reasons that survive:
//
//   · the debounce, because a request per keystroke is still a request per
//     keystroke, and because the server falls back to the old scan when the
//     search index is missing or still building;
//   · the 3-character floor, because it is now about the ANSWER rather than the
//     cost. The index tokenises from 2 characters, so "du" resolves quickly and
//     then matches a large slice of the base — a list that long is not an
//     answer to anything.
//
// Shortened to 300ms: at a lookup per search there is no longer a reason to
// make someone stop typing and wait before they see anything.
//
// Clearing the input (length 0) still reloads the unfiltered list.
export const SEARCH_DEBOUNCE_MS = 300;
export const MIN_SEARCH_CHARS = 3;

export const isSearchable = (input) => {
    const n = (input || '').trim().length;
    return n === 0 || n >= MIN_SEARCH_CHARS;
};

// A second, lower floor for the boxes whose cost argument does not apply but
// whose INDEX still cannot answer a one-character query.
//
// `doctors_search` maps FName/LName as autocomplete with minGrams: 2, and the
// autocomplete operator returns nothing below minGrams; the companion text
// clause goes to lucene.french, which drops single letters as stopwords. So the
// very first keystroke resolved to zero rows, where the old contains regex had
// returned nearly every doctor (measured: "a" gave 6 rows against the regex's
// 1 246). Empty-looking results on keystroke one read as a broken screen.
//
// Two characters, because that is the index's own minGrams — not three, which
// is the patient floor and exists for a different reason (a 2-character prefix
// matching a large slice of ~962k users).
export const MIN_INDEX_CHARS = 2;

export const isIndexSearchable = (input) => {
    const n = (input || '').trim().length;
    return n === 0 || n >= MIN_INDEX_CHARS;
};
